import axios from 'axios'
import {asResponse} from '../util'
import {mutate} from 'swr'

export const ME_SWR_KEY = `/bff/users/me`

export const getMe = async (url) => {
  const resp = await asResponse(axios.get(url))
  return {
    me: resp.data || {accounts: []}
  }
}

export const USER_SWR_KEY = ({userId}) => [
  '/bff/users/${userId}',
  userId
]

export const getUser = async (url, userId) => {
  let resp = {}
  try {
    resp = await asResponse(axios.get(url.replace('${userId}', userId)))
  } catch (e) {

  }
  return {
    user: resp.data || {accounts: []}
  }
}

export const USERS_SWR_KEY = '/bff/users?load=invitations&limit=1000'

export const getUsers = async (url) => {
  const response = await asResponse(axios.get(url))
  const users = response.data.results
  return {
    users
  }
}

export const mutateUser = async function () {
  let args = Array.from(arguments)
  args = [USER_SWR_KEY, ...args]
  return mutate.apply(this, args)
}

export const login = async (credentials) => {
  const resp = await asResponse(axios.post('/bff/users/login', credentials))
  const user = resp.data
  // window.localStorage.setItem('sid', user.sessionId)
  // axios.defaults.headers.common['x-sid'] = user.sessionId
  return user
}

export const logout = async () => {
  const resp = await asResponse(axios.post('/bff/users/logout'))
  // window.localStorage.removeItem('sid')
  // delete axios.defaults.headers.common['x-sid']
  return resp.data
}

export const activateAccount = async (accountId) => {
  const resp = await asResponse(axios.post('/bff/users/activate-account', {accountId}))
  return resp.data
}

export const updateProfile = async (profile) => {
  const resp = await asResponse(axios.post('/bff/users/update-profile', profile))
  return resp.data
}

export const changePassword = async (state) => {
  const resp = await asResponse(axios.post('/bff/users/update-password', state))
  return resp.data
}

export const toggleUserAsAdmin = async (user) => {
  const resp = await asResponse(axios.post(`/bff/users/toggle-as-admin`, {userId: user.id}))
  return resp.data
}

export const setUserAsBillingOwner = async (user) => {
  const resp = await asResponse(axios.post(`/bff/users/set-as-billing-owner`, {userId: user.id}))
  return resp.data
}

export const upsertUser = async (user) => {
  const verb = user.id ? 'put' : 'post'
  const path = user.id ? `/bff/users/${user.id}` : `/bff/users`
  const resp = await asResponse(axios[verb](path, user))
  return resp.data
}

export const sendInvitation = async (user) => {
  await asResponse(axios.post('/bff/users/send-invitation', user))
}

export const removeUser = async (user) => {
  await asResponse(axios.post(`/bff/users/remove-from-account`, {userId: user.id}))
}

export const loginAsSuperUser = async (accountId) => {
  const resp = await asResponse(axios.post('/bff/users/login-as-super-user', {accountId}))
  const user = resp.data
  return user
}

export const logoutAsSuperUser = async () => {
  const resp = await asResponse(axios.post('/bff/users/logout-as-super-user'))
  const user = resp.data
  return user
}

